import { PIN_POST_SUCCESS } from '../../actions/pin-post';
import { UNPIN_POST_SUCCESS } from '../../actions/unpin-post';
import { categoryIds } from '../event-helpers';

const handler = ({ type, payload }) => ({
  evid: 230,
  isPinned: type === PIN_POST_SUCCESS ? 1 : 0,
  category_ids: categoryIds(payload), // todo, [bug] categories are not set in state in members area posts and drafts page
  post_id: payload._id,
});

export const uouTogglePinPostEvent = {
  [PIN_POST_SUCCESS]: handler,
  [UNPIN_POST_SUCCESS]: handler,
};
